import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorEventsDataProviderFactory } from '../factory/IntegrityMonitorEventsDataProviderFactory';
import { IntegrityMonitorEventsDataProvider } from '../dataProvider/IntegrityMonitorEventsDataProvider';
import { IntegrityMonitorEventsWebComponentSchema } from '../types';

export class IntegrityMonitorEventsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorEventsDataProviderFactory;
  public dataProvider: IntegrityMonitorEventsDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorEventsDataProviderFactory(),
    });
  }

  public async getDataForView(): Promise<IntegrityMonitorEventsWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }

  public async updateCategory(records: Array<object>, newCategory: string): Promise<any> {
    return this.dataProvider.updateCategories(records, newCategory);
  }
}
